'use client';

import { BlogPost } from '@/components/Blog/BlogPost';
import { motion } from 'motion/react';

const BLOG_POSTS = [
  {
    id: '5',
    title: 'Protecting your Solana Wallets from Phishing and Hacks',
    date: '2025-05-08',
    content:
      'Discover essential tips and best practices to keep your Solana wallets safe from phishing attempts and hacks.',
    image: '/blog-no-phishing.png',
    link: 'https://x.com/armory_co/status/1920597612048097762',
  },
  {
    id: '4',
    title: 'Token Sniping: What is it, and why is it slowly destroying meme coins',
    date: '2025-05-04',
    content:
      'Learn how token sniping bots exploit new launches, undermining fair trading, and damaging to meme coin communities.',
    image: '/blog-sniper.png',
    link: 'https://x.com/armory_co/status/1919240971201523875',
  },
  {
    id: '3',
    title: 'Are there alternatives to @pumpdotfun? 🤔',
    date: '2025-04-29',
    content:
      'Explore the landscape of meme coin launchpads and discover platforms that offer alternatives to @pumpdotfun.',
    image: '/blog-alternative-pumpfun.png',
    link: 'https://x.com/armory_co/status/1917289257921663006',
  },
  {
    id: '2',
    title: 'Why are shady KOLs so prevalent, and how to avoid them',
    date: '2024-04-16',
    content:
      'Learn about the prevalence of shady Key Opinion Leaders in crypto and discover strategies to identify and avoid them.',
    image: '/blog-shady-kol.png',
    link: 'https://x.com/armory_co/status/1912690979271770574',
  },
  {
    id: '1',
    title: 'AntiRug Chrome Extension Coming Soon',
    date: '2025-02-14',
    content:
      'Chrome extension pending review. Requires 10k $ANTIRUG tokens to access. Features include real-time rug detection.',
    image: '/logo-optimized.svg',
    link: 'https://x.com/AntiRugAgent/status/1889358738902983107',
  },
];

export function BlogList() {
  // Sort posts by id in descending order
  const sortedPosts = [...BLOG_POSTS].sort((a, b) => Number(b.id) - Number(a.id));

  return (
    <div className="border-t border-gray-700 pt-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {sortedPosts.map((post, index) => (
          <motion.div
            key={post.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
          >
            <BlogPost post={post} />
          </motion.div>
        ))}
      </div>
    </div>
  );
}
